import type { ReactNode } from 'react';
import { GoToTop } from './GoToTop';
import { Header, type TrendingItem } from './Header';
import { Footer } from './Footer';
import type { CategoryItem } from './Menu';

export function RootLayout({
  children,
  categories = [],
  mainCategories = [],
  otherCategories = [],
  trending = [],
}: {
  children: ReactNode;
  categories?: CategoryItem[];
  mainCategories?: CategoryItem[];
  otherCategories?: CategoryItem[];
  trending?: TrendingItem[];
}) {
  return (
    <>
      <Header categories={categories} trending={trending} />
      {/* Every page was header + bare content + footer, with nothing marking
          where the page's own content starts. */}
      <main id="main">{children}</main>
      <Footer mainCategories={mainCategories} otherCategories={otherCategories} />
      <GoToTop />
    </>
  );
}
